import React, { Component } from 'react';
import Main from './seiten/Main';

import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      device: undefined,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <Router>
        <Switch>
          <Route path="/">
            <Main history={history} />
          </Route>
        </Switch>
      </Router>
    );
  }
}
